import Container from "./containers";
import React from "react";
import { AuthProvider } from "@descope/react-sdk";

const AppRoot = () => {
	return (
		<AuthProvider projectId={process.env.REACT_APP_DESCOPE_PROJECT_ID}>
			<App />
		</AuthProvider>
	);
};

const App = () => {
	return (
		<div className="App">
			<Container />
		</div>
	);
};

export default AppRoot;
